import React from 'react';
import SearchBar from '../components/SearchBar';
import StateGrid from '../components/StateGrid';
import SEO from '../components/SEO';
import { getCanonicalUrl } from '../utils/url';

export default function Home() {
  return (
    <>
      <SEO 
        title="Find Reiki Practitioners Near You | Reiki Near Me"
        description="Find certified Reiki practitioners in your area. Browse our directory of healers across the USA or search by city and state."
        canonicalUrl={getCanonicalUrl('/')}
      />

      <div className="bg-gradient-to-b from-purple-50 to-white dark:from-dark dark:to-dark-secondary">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-24">
          <h1 className="text-4xl md:text-5xl font-bold text-center text-gray-900 dark:text-white mb-8">
            Find Reiki Practitioners Near You
          </h1>
          <p className="text-xl text-center text-gray-600 dark:text-gray-300 mb-12 max-w-3xl mx-auto">
            Connect with certified Reiki healers in your area. Browse our directory of practitioners across the USA or search by location.
          </p>
          <SearchBar />
        </div>
      </div>

      <section className="py-12">
        <h2 className="text-2xl font-semibold text-center text-gray-900 dark:text-white mb-8">
          Browse by State
        </h2>
        <StateGrid />
      </section>
    </>
  );
}